export default __webpack_public_path__ + "media/images/home/slide_october_holiday_2026_sm-cf593dce3af887f759f4134ecc2ecbd5.jpg";